import s from "../../utils/esm/generateUtilityClasses/generateUtilityClasses.js";
import e from "../../utils/esm/generateUtilityClass/generateUtilityClass.js";
function a(t) {
  return e("MuiButtonBase", t);
}
const l = s("MuiButtonBase", ["root", "disabled", "focusVisible"]);
export {
  l as default,
  a as getButtonBaseUtilityClass
};
